import {
    ProjectExpensePaymentInstallmentBody,
    ProjectExpensePaymentInstallmentDto,
} from "@project/data/dto/expenses/payment-installment.dto";
import { ProjectExpensePaymentInstallment } from "@project/domain/models/expenses/expense.model";
import { DateTime } from "luxon";

export const mapProjectExpensePaymentInstallments = (
    installments?: ProjectExpensePaymentInstallmentDto[] | null,
): ProjectExpensePaymentInstallment[] | undefined =>
    installments?.map(
        (installment) =>
            new ProjectExpensePaymentInstallment(
                installment.payment_date
                    ? DateTime.fromISO(installment.payment_date)
                    : null,
                parseFloat(installment.amount),
                installment.position ?? 0,
                installment.id,
            ),
    );

export const mapProjectExpensePaymentInstallmentsToBody = (
    installments?: ProjectExpensePaymentInstallment[] | undefined,
): ProjectExpensePaymentInstallmentBody[] | undefined =>
    installments?.map((installment) => ({
        payment_date: installment.paymentDate?.toISODate() ?? "",
        amount: installment.amount.toFixed(2),
        position: installment.position,
    }));

export const mapProjectExpensePaymentInstallmentsFromForm = (
    usePaymentInstallments: boolean,
    installments?: Array<{
        paymentDate: DateTime | null;
        amount: number | null;
        position: number;
        id?: number | undefined;
    }> | null,
): ProjectExpensePaymentInstallment[] | undefined => {
    if (!usePaymentInstallments) {
        return undefined;
    }

    return installments?.map(
        (installment) =>
            new ProjectExpensePaymentInstallment(
                installment.paymentDate,
                installment.amount ?? 0,
                installment.position,
                installment.id,
            ),
    );
};
